var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","overflow":"hidden"}},[_c('el-cascader',{staticStyle:{"min-width":"240px","width":"100%"},style:({ width: _vm.width }),attrs:{"options":_vm.options,"placeholder":"请选择所在地区(选填)","value":_vm.region_,"separator":' '},on:{"change":_vm.regionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }